import React, { useContext, Component, useRef, useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AppContext from "../../AppContext";
//import AdminNavbar from "./navbar/AdminNavbar";
import {
  MDBBtn,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBIcon,
  MDBInputGroup,
  MDBLoadingManagement,
} from "mdb-react-ui-kit";

//import logo from "../../assets/media/logo/Logo_Bergfrei_250px-180w.png";

import Cookies from "universal-cookie";

const cookies = new Cookies();

function AdminLoginPage() {
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const passwordRef = useRef();
  const buttonRef = useRef();
  const colorsRef = useRef(null);
  const [hidePassword, setHidePassword] = useState(true);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (context.isLoggedIn()) navigate("/admin");
  }, []);

  const onUsernameChange = (event) => {
    //this.setState({ username: event.target.value });
  };

  const onPasswordChange = (event) => {
    //this.setState({ password: event.target.value });
  };

  const onLoginFormSubmit = (event) => {
    event.preventDefault();
    console.log(password, email);
    context.interAxios.post(
      "/auth/login",
      { password: password, email: email },
      function (response) {
        context.onSignIn(response.data);
        navigate("/admin");
      },
      function (error) {
        alert("incorrect email or password");
      },
    );
  };

  return (
    <div className="admin-login-page">
      <MDBContainer className="adminLanding-container">
        <div style={{ maxWidth: "300px" }}>
          <p className="login-title">Please login to your admin account</p>

          <form onSubmit={(e) => onLoginFormSubmit(e)} className="signin-form-admin" autoComplete="off">
            {/** EMAIL **/}
            <div className="input-div-2">
              <label htmlFor="firstName">Email</label>
              <br />
              <input
                id="email"
                name="email"
                type="text"
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key == "Tab") {
                    e.preventDefault();
                    e.stopPropagation();
                    passwordRef.current.focus();
                  }
                }}
                value={email}
                required
              />
            </div>
            {/** PASSWORDs **/}
            <div className="input-div-2">
              <label htmlFor="password">Password</label>
              <br />
              <MDBInputGroup
                className="jc-password"
                noWrap
                textAfter={
                  <MDBIcon
                    className={"fa-regular" + (hidePassword ? " fa-eye" : " fa-eye-slash")}
                    onClick={() => setHidePassword(!hidePassword)}
                  ></MDBIcon>
                }
              >
                <input
                  type={hidePassword ? "password" : "text"}
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                  }}
                  ref={passwordRef}
                  id="password"
                  name="password"
                  onKeyDown={(e) => {
                    if (e.key == "Tab") {
                      e.preventDefault();
                      e.stopPropagation();
                      buttonRef.current.focus();
                    }
                  }}
                  required
                />
              </MDBInputGroup>
            </div>
            <div className="input-div-2 d-flex align-items-center justify-content-center">
              <button
                type="button"
                className="rergistration-button modal-button text-button"
                onClick={() => {
                  context.openModal("forgotpassword");
                }}
              >
                <span>Forgot password?</span>
              </button>
            </div>
            <div className="input-div  d-flex align-items-center justify-content-center">
              <button type="submit" className="rergistration-button admin modal-button green" ref={buttonRef}>
                <span>Sign In</span>
              </button>
            </div>
          </form>
        </div>
      </MDBContainer>
    </div>
  );
}

export default AdminLoginPage;
